import ApplyClass from './util/_apply-class';
import Form from './controller/_form';
import Product from './controller/_product';

import HeaderMenuView from './view/_header-menu-view';
import AnchorToggleView from './view/_anchor-toggle-view';
import SliderView from './view/_slider-view';
import TopShopSelectView from './view/_top-shop-select-view';

const FormController = new Form();
import FormValidateView from './view/_form-validate-view';
import FormSubmitView from './view/_form-submit-view';
import FormCardYearView from './view/_form-card-year-view';
import FormNameDivideView from './view/_form-name-divide-view';
import FormAgreeView from './view/_form-agree-view';
import FormDatePickerView from './view/_form-date-picker-view';

const ProductController = new Product();
import OptionModalView from './view/_option-modal-view';
import SetOptionView from './view/_set-option-view';
import FeeProductInitializeView from './view/_fee-product-initialize-view';
import CartAlertView from './view/_cart-alert-view';
import BtnReCalculateView from './view/_btn-re-calculate-view';
import PriceCalculateView from './view/_price-calculate-view';
import CheckboxOptionTypeView from './view/_checkbox-option-type-view';
import ShowCartButtonView from './view/_show-cart-button-view';
import ReceiveDateDisabledView from './view/_receive-date-disabled-view';
import RadioOptionView from './view/_radio-option-view';
import RadioOptionSelectView from './view/_radio-option-select-view';
import BtnCancelView from './view/_btn-cancel-view';

import ChangeShopModalView from './view/_change-shop-modal-view';
import ShopPageLinkView from './view/_shop-page-link-view';

import SelectSkuView from './view/_select-sku-view';

import CheckUrlView from './view/_check-url-view';
import FormChangeMessageVisibilityControlView from './view/_form-change-message-visibility-control-view';

(function ($) {

	$(function () {
		/* basic系 */
		$('a.drawer-open').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(HeaderMenuView, $e, [$e]);
		});
		$('.anchor-toggle').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(AnchorToggleView, $e, [$e]);
		});
		$('.slider').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(SliderView, $e, [$e]);
		});
		$('input[name=init_flg]').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(TopShopSelectView, $e, [$e]);
		});


		/* form系 */
		$('.validate').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormValidateView, $e, [$e, FormController]);
		});
		$('button[type=submit][data-form]').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormSubmitView, $e, [$e, FormController]);
		});
		$('.card_year').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormCardYearView, $e, [$e]);
		});
		$('.user_name').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormNameDivideView, $e, [$e]);
		});
		$('.agree').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormAgreeView, $e, [$e]);
		});
		$('.message-visibility-control').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormChangeMessageVisibilityControlView, $e, [$e]);
		});
		$('[data-datepicker=true]').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormDatePickerView, $e, [$e, FormController]);
		});


		/* cart系 */
		$('.btn.buy-together').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(OptionModalView, $e, [$e]);
		});
		$('.btn.set-option').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(SetOptionView, $e, [$e, ProductController]);
		});
		$('div.feeProduct').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FeeProductInitializeView, $e, [$e, ProductController]);
		});
		$('input.message').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(CartAlertView, $e, [$e]);
		});
		$('.text-cart-price.text-total strong').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(PriceCalculateView, $e, [$e, ProductController]);
		});
		$('.btn-re-calculate').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(BtnReCalculateView, $e, [$e]);
		});
		$('.recieveDate option').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(ReceiveDateDisabledView, $e, [$e]);
		});


		/* product */
		$('.has-option').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(RadioOptionView, $e, [$e]);
		});
		$('.option-type').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(RadioOptionSelectView, $e, [$e]);
		});
		$('.btn-cancel').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(BtnCancelView, $e, [$e]);
		});
		$('.block-option-info').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(CheckboxOptionTypeView, $e, [$e]);
		});
		$('.block-cart-btn-fix').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(ShowCartButtonView, $e, [$e]);
		});

		/* shop */
		$('.change-shop-btn').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(ChangeShopModalView, $e, [$e]);
		});
		$('html.shop').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(ShopPageLinkView, $e, [$e]);
		});

		$('.list-sku .btn-select-sku').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(SelectSkuView, $e, [$e]);
		});

		$('.check-url').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(CheckUrlView, $e, [$e]);
		});
	});
})(jQuery);
